export const CONTENT_TAB_SET_ROUTE = 'CONTENT_TAB_SET_ROUTE'